export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const resolvePromiseAfter = async <T>(ms: number, promise: Promise<T>): Promise<T> => {
  const ret = await Promise.all([promise, sleep(ms)]);
  return ret[0];
};
